import { render, staticRenderFns } from "./ARecordListEditor.vue?vue&type=template&id=147eafc2&"
import script from "./ARecordListEditor.vue?vue&type=script&lang=js&"
export * from "./ARecordListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports